import logo from "../../../../assets/images/logo_light.svg";
import reportHeader from "../../../../assets/images/report_header.svg";
import { formatAmount, formatPhoneNumber } from "../../../../utils/appUtils";

const MAX_ROWS_PER_PAGE = 9;

const TdsReport = ({
    data = [],
    reportTitle = "TDS AMOUNT REPORTS",
    summary = {},
    gstin = "33AAUCM1496R1ZG"
}) => {
    const totalTdsCount = Number(summary?.totalTdsCount ?? data?.length) || 0;
    const totalTdsAmount = Number(summary?.totalTdsAmount ?? data?.reduce((sum, item) => sum + (Number(item?.tdsAmount) || 0), 0)) || 0;

    const paginatedRows = data?.length
        ? Array.from({ length: Math.ceil(data?.length / MAX_ROWS_PER_PAGE) }, (_, pageIndex) => {
            const startIndex = pageIndex * MAX_ROWS_PER_PAGE;
            const endIndex = startIndex + MAX_ROWS_PER_PAGE;
            return data?.slice(startIndex, endIndex);
        })
        : [[]];

    return (
        <div className="tax-invoice-report">
            {
                paginatedRows?.map((pageRows, pageIndex) => {
                    const pageTotalEarnedAmount = pageRows?.reduce((accumulator, detail) => accumulator + (Number(detail?.earnedAmountAboveTds) || 0), 0);
                    const pageTotalTdsAmount = pageRows?.reduce((accumulator, detail) => accumulator + (Number(detail?.tdsAmount) || 0), 0);

                    return (
                        <div key={`${pageIndex}`} className="tax-report-page">
                            <div className="tax-report-sheet">
                                <div className="tax-report-header">
                                    <div className="tax-report-branding">
                                        <img src={logo} alt="MLawyer" />
                                        <div className="tax-report-brand-text">
                                            <h1>MLawyer</h1>
                                            <h3>GSTIN: {gstin}</h3>
                                        </div>
                                    </div>
                                    <div className="tax-report-header-shape" aria-hidden="true">
                                        <img src={reportHeader} alt="" />
                                    </div>
                                </div>
                                <h2 className="tax-report-title">{reportTitle}</h2>
                                <div className="tax-report-summary-strip">
                                    <div className="tax-report-summary-item">
                                        <p>Total Count</p>
                                        <h4>{formatAmount(totalTdsCount)}</h4>
                                    </div>
                                    <div className="tax-report-summary-item">
                                        <p>Total TDS Amount</p>
                                        <h4>₹{formatAmount(totalTdsAmount)}</h4>
                                    </div>
                                </div>
                                <div className="tax-report-table-wrapper">
                                    <div className="tax-report-watermark" aria-hidden="true">
                                        <img src={logo} alt="" />
                                    </div>
                                    <table className="tax-report-table tds-report-table">
                                        <thead>
                                            <tr>
                                                <th>SNo</th>
                                                <th>Advocate ID</th>
                                                <th>Advocate Name</th>
                                                <th>PAN Num</th>
                                                <th>Mobile NO</th>
                                                <th>Email ID</th>
                                                <th>Earned amount above TDS</th>
                                                <th>TDS Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                pageRows?.map((detail, rowIndex) => {
                                                    const serialNumber = (pageIndex * MAX_ROWS_PER_PAGE) + rowIndex + 1;
                                                    return (
                                                        <tr key={detail?.id || detail?.key || `${pageIndex}-${rowIndex}`}>
                                                            <td>{serialNumber}</td>
                                                            <td>{detail?.lawyerNo || "Nil"}</td>
                                                            <td>{detail?.name || "Nil"}</td>
                                                            <td>{detail?.panNum || "Nil"}</td>
                                                            <td>{formatPhoneNumber(detail?.mobileNumber) || detail?.mobileNumber || "Nil"}</td>
                                                            <td>{detail?.email || "Nil"}</td>
                                                            <td>₹{formatAmount(detail?.earnedAmountAboveTds)}</td>
                                                            <td>₹{formatAmount(detail?.tdsAmount)}</td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={6} className="tax-report-total-label">Total</td>
                                                <td>₹{formatAmount(pageTotalEarnedAmount)}</td>
                                                <td>₹{formatAmount(pageTotalTdsAmount)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default TdsReport;
